export default __webpack_public_path__ + "static/media/handbookImg.1848cd88.png";